import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { authFetch } from "../context/AuthContext";

const SIGN_GLYPH = {
    Aries: "♈", Taurus: "♉", Gemini: "♊", Cancer: "♋", Leo: "♌", Virgo: "♍",
    Libra: "♎", Scorpio: "♏", Sagittarius: "♐", Capricorn: "♑", Aquarius: "♒", Pisces: "♓",
};

function timeAgo(iso) {
    if (!iso) return "";
    const seconds = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
    if (seconds < 60) return "just now";
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h`;
    if (seconds < 604800) return `${Math.floor(seconds / 86400)}d`;
    return new Date(iso).toLocaleDateString();
}

export default function Messages() {
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        authFetch("get", "/messages/inbox/list")
            .then((r) => setConversations(r.data.conversations))
            .finally(() => setLoading(false));
    }, []);

    return (
        <>
            <Navbar />
            <main className="min-h-screen pt-28 pb-12 px-6">
                <div className="max-w-2xl mx-auto">
                    <p className="label-tracking text-gold">Conversations</p>
                    <h1 className="font-serif text-5xl mt-2">Whispers Across the Stars</h1>

                    {loading && <p className="text-muted mt-10">Loading...</p>}

                    {!loading && conversations.length === 0 && (
                        <div className="glass p-12 text-center mt-8" data-testid="empty-inbox">
                            <p className="font-serif text-2xl">No conversations yet</p>
                            <p className="text-muted mt-3">Once you and another soul like each other, your conversation begins here.</p>
                            <Link to="/matches" className="btn-gold-solid inline-block mt-6" data-testid="empty-inbox-cta">
                                Find Connections
                            </Link>
                        </div>
                    )}

                    <div className="space-y-3 mt-8">
                        {conversations.map((c) => (
                            <Link
                                key={c.match_id}
                                to={`/messages/${c.match_id}`}
                                className="glass hover-lift p-5 flex items-center gap-4 block"
                                data-testid={`conversation-${c.match_id}`}
                            >
                                {/* Avatar with sign */}
                                <div className="relative w-14 h-14 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-2xl text-gold flex-shrink-0">
                                    {c.other_user.picture ? (
                                        <img src={c.other_user.picture} alt="" className="w-full h-full rounded-full object-cover" />
                                    ) : (
                                        <span className="font-serif">{SIGN_GLYPH[c.other_user.sun] || "✦"}</span>
                                    )}
                                    {c.unread_count > 0 && (
                                        <span
                                            className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-gradient-to-br from-[#E6C387] to-[#F5D68F] text-[#03030A] text-[10px] font-semibold flex items-center justify-center"
                                            data-testid={`unread-${c.match_id}`}
                                        >
                                            {c.unread_count}
                                        </span>
                                    )}
                                </div>
                                {/* Content */}
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-baseline justify-between gap-2">
                                        <h3 className="font-serif text-xl truncate">{c.other_user.name}</h3>
                                        <span className="text-xs text-muted whitespace-nowrap">
                                            {timeAgo(c.last_message?.created_at || c.matched_at)}
                                        </span>
                                    </div>
                                    <p className={`text-sm truncate mt-1 ${c.unread_count > 0 ? "text-foreground" : "text-muted"}`}>
                                        {c.last_message
                                            ? c.last_message.text
                                            : <span className="italic">Send the first message...</span>}
                                    </p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </main>
        </>
    );
}
